import { combineReducers, configureStore } from '@reduxjs/toolkit';
import themeConfigSlice from './themeConfigSlice';

export const rootReducer = combineReducers({
  themeConfig: themeConfigSlice,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;

// Only if you need the root state type here too
export type IRootState = ReturnType<typeof rootReducer>;
